export default __webpack_public_path__ + "static/Mam Hareem-b2eb2efa8aee587cee3c4703a9904fe8.png";